import React, {Component, Fragment} from 'react';
import axios from 'axios'
import moment from 'moment';
import debounce from 'lodash/debounce';

import RequisitionSubmitModal from './RequisitionSubmitModal';
import Pagination from '../elements/Pagination';
import Loader from '../elements/Loader';
import CheckBox from '../elements/CheckBox'
import {phoneNumberMask, states, dateMask} from '../utilities';


class Item extends Component {
  constructor(props){
    super(props);
    this.state = {
      id: props.id,
      accessionID: props.accessionID,
      requisitionID: props.requisitionID ? props.requisitionID : '',
      orderNumber: props.orderNumber,
      date: props.date,
      lastName: props.lastName,
      firstName: props.firstName,
      dob: moment.utc(props.dob).format("MM/DD/YYYY"),
      email: props.email,
      phone: props.phone,
      status: props.status,
      result: props.result ? props.result:"",
      isPCR: props.isPCR,
      sex: props.sex,
      address: props.address,
      city: props.city,
      state: props.state,
      zip: props.zip,
      showSubmitModal: false,
      labelCopies: 2,
      edit: false,
      test: props.test,
      openModal: false,
      confirming: false,
      resending: false,
      testModal: false,
      covidPcr: false,
      nab: false,
      panel: false,
      flu: false,
      error: '',
    }
  }

  handleChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    if(name === 'phone'){
      value = phoneNumberMask(value)
    } else if(name === 'dob'){
      value = dateMask(value)
    } else {
      value = value;
    }
    this.setState({
      [name]: value
    })
  }

  onChange = (key, value, e) => {
    this.setState({[key]:value})
  }

  edit = () => {
    this.setState({
      edit: !this.state.edit
    })
  }

  confirm = () => {
    this.setState({
      confirming: true
    })
    let formData = {
      result: this.state.result
    };
    axios({
      method: 'PUT',
      url: `${process.env.REACT_APP_URL}/antigen/${this.state.id}`,
      data: formData,
    }).then(res => {
      this.setState({
        status: 'Final',
        openModal: false,
        confirming: false,
      })
    }).catch(err => {
      console.log(err)
    });
  }

  confirmLab = () => {
    this.setState({
      confirming: true
    })
    let formData = {
      result: this.state.result
    };
    axios({
      method: 'PUT',
      url: `${process.env.REACT_APP_URL}/antigen/${this.state.id}`,
      data: formData,
    }).then(res => {
      this.setState({
        status: 'Final',
        openModal: false,
        confirming: false,
      })
    }).catch(err => {
      console.log(err)
    });
  }

  resend = () => {
    this.setState({
      resending: true
    })
    axios({
      method: 'PUT',
      url: `${process.env.REACT_APP_URL}/resend/${this.state.id}`,
    }).then(res => {
      this.setState({
        resending: false
      })
    }).catch(err => {
      console.log(err)
    });
  }

  send = () => {
    this.setState({
      isPCR: 1
    })
    axios({
      method: 'GET',
      url: `${process.env.REACT_APP_URL}/pcr/${this.state.id}/receipt`,
    }).then(res => {
      this.setState({
        requisitionID: res.data.item.requisitionID
      })
    }).catch(err => {
      console.log(err)
    });
  }

  submit = () => {
    console.log("Click")
    this.setState({
      openModal: !this.state.openModal
    })
  }

  submitToLab = () => {
    console.log("Click")
    this.setState({
      testModal: !this.state.testModal
    })
  }

  update = () => {
    let formData = {
      firstName: this.state.firstName,
      lastName: this.state.lastName,
      dob: moment(this.state.dob).format('YYYY-MM-DD'),
      sex: this.state.sex,
      address: this.state.address,
      city: this.state.city,
      state: this.state.state,
      zip: this.state.zip,
      email: this.state.email,
      phone: this.state.phone,
      test: this.state.test,
    };
    axios({
      method: 'PATCH',
      url: `${process.env.REACT_APP_URL}/antigen/${this.state.id}`,
      data: formData,
    }).then(res => {
      this.setState({
        edit: false
      })
    }).catch(err => {
      console.log(err)
    });
  }

  print = () => {  
    let error = '';
    let test = ''
    if (this.state.covidPcr){
      test = 'pcr'
      if (this.state.nab){
        test = 'pcrNab'
      }
    }
    if (this.state.flu){
      test = 'flu'
      if (this.state.nab){
        test = 'fluNab'
      }
    }
    if (this.state.panel){
      test = 'panel'
      if (this.state.nab){
        test = 'panelNab'
      }
    }    

    if (!this.state.nab && !this.state.panel && !this.state.covidPcr && !this.state.flu){
      error = 'Please select a test'
    }
    if (error){
      this.setState({
        error: error
      })
    } else {
      let formData = {
        test: test,
      }
      axios({
        method: 'PATCH',
        url: `${process.env.REACT_APP_URL}/antigen/${this.state.id}`,
        data: formData,
      }).then(res => {
        let PCR = this.state.showSubmitModal ? 1:0;
        this.setState({
          testModal: false,
          showSubmitModal: !this.state.showSubmitModal,
          isPCR: PCR
        })
      }).catch(err => {
        console.log(err)
      });
    }        
  }

  reprint = () => {
    this.setState({
      showSubmitModal: !this.state.showSubmitModal,
    })
  }

  report = () => {
    window.open(`${process.env.REACT_APP_URL_API || ''}/v0/antigen/${this.state.id}/report`)
  }

  renderModal(){
    console.log("RENDER MODAL")
    return(
      <div className="modal inmodal" style={{"display": (this.state.openModal) ? 'block' : 'none' }} tabIndex="-1">
        <div className="modal-dialog modal-sm">
          <div className="modal-content">
            <div className="modal-header">
              <button type="button" className="close" data-dismiss="modal" onClick={this.submit}>
                <span aria-hidden="true">x</span>
              </button>
              <h4 className="modal-title">Are you sure you want to finalize test as <span style={{color: 'red'}}>{this.state.result} </span> for patient <span style={{color: 'red'}}>{this.state.firstName} {this.state.lastName}</span> dob: <span style={{color: 'red'}}>{moment.utc(this.state.dob).format("MM/DD/YYYY")}</span>? </h4>
            </div>
            <div className="modal-footer">
              <div className="button-group">
                <button className="btn btn-primary" onClick={this.confirm}>{this.state.confirming ? <Loader/> : 'Confirm'}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  testModal(){
    console.log("RENDER MODAL")
    return(
      <div className="modal inmodal" style={{"display": (this.state.testModal) ? 'block' : 'none' }} tabIndex="-1">
        <div className="modal-dialog modal-sm">
          <div className="modal-content">
            <div className="modal-header">
              <button type="button" className="close" data-dismiss="modal" onClick={this.submitToLab}>
                <span aria-hidden="true">x</span>
              </button>
              <h4>Name: <span style={{color: 'red'}}>{this.state.firstName} {this.state.lastName}</span></h4>
              <h4>DOB: <span style={{color: 'red'}}>{moment.utc(this.state.dob).format("MM/DD/YYYY")}</span></h4>
            </div>
            <div className='modal-body'>
              <div className='row'>
                <div className='col-xs-3'>
                  <CheckBox property="covidPcr" value={Boolean(this.state.covidPcr)} onChange={this.onChange}/>
                </div>
                <div className='col-xs-9'>
                  Covid-19 RNA, QL RT-PCR
                </div>
              </div>
              <div className='row'>
                <div className='col-xs-3'>
                  <CheckBox property="nab" value={Boolean(this.state.nab)} onChange={this.onChange}/>
                </div>
                <div className='col-xs-9'>
                  Covid-19 Neutralizing Antibody
                </div>
              </div>
              <div className='row'>
                <div className='col-xs-3'>
                  <CheckBox property="panel" value={Boolean(this.state.panel)} onChange={this.onChange}/>
                </div>
                <div className='col-xs-9'>
                  FluA/FluB/RSV/SARS-CoV-2
                </div>
              </div>
              <div className='row'>
                <div className='col-xs-3'>
                  <CheckBox property="flu" value={Boolean(this.state.flu)} onChange={this.onChange}/>
                </div>
                <div className='col-xs-9'>
                  FluA/FluB/SARS-CoV-2
                </div>
              </div>
              {this.state.error ?
                <div className='row'>                
                  <div className='col-xs-12'>
                    <p style={{color: 'red'}}>{this.state.error}</p>
                  </div>
                </div> : null
              }              
            </div>
            <div className="modal-footer">
              <div className="button-group">
                <button className="btn btn-primary" onClick={this.print}>Confirm</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  render(){    
    let label;
    switch (this.state.status){
      case 'Final':
        label = 'label-primary';
        break;
      case 'Pending':
        label = 'label-warning';
        break;
      case 'Accessioned':
        label = 'label-success';
        break;
      default:
        break;
    }
    return(
      <Fragment>
        <tr>
          <td className="hidden-sm hidden-md hidden-lg">{this.state.lastName}, {this.state.firstName} <span className='pull-right' style={{fontWeight: 'bold'}}>{this.state.requisitionID}</span></td>
          <td className="hidden-sm hidden-md hidden-lg">
            {this.state.isPCR ? 
              <h5>SENT</h5>:<button className="btn btn-sm btn-primary" onClick={this.send}>Send PCR</button>
            }
          </td>
          <td className="hidden-xs">{this.state.orderNumber}</td>
          <td className="hidden-xs">{moment(this.state.date).format("MM/DD/YYYY HH:mm")}</td>
          <td className="hidden-xs">{this.state.lastName}</td>
          <td className="hidden-xs">{this.state.firstName}</td>
          <td className="hidden-xs">{moment.utc(this.state.dob).format("MM/DD/YYYY")}</td>
          <td className="hidden-xs">{this.state.phone}</td>
          <th className="hidden-xs">{this.state.accessionID}</th>
          <td className="hidden-xs" style={{textAlign: 'center'}}>{this.state.test === 'pcr' ? <h5>PCR ONLY</h5>:<label className={`label ${label}`}>{this.state.status}</label>}</td>
          <td style={{textAlign: 'center'}} className={`hidden-xs ${this.state.status === 'Final' ? this.state.result === 'POSITIVE' ? 'danger': '': ''}`}>
            {this.state.status === 'Final' ? 
              <h3><a onClick={this.report}>{this.state.result.toUpperCase()}</a></h3>
              :
              this.state.status === 'Accessioned' ?
              <select className="form-control input-sm" name='result' value={this.state.result} onChange={this.handleChange}>
                <option value="">Select</option>
                <option value="NEGATIVE">NEGATIVE</option>
                <option value="POSITIVE">POSITIVE</option>
              </select> : this.state.test === 'pcr' ? <h5>PCR ONLY</h5>:<h5>NOT ACCESSIONED</h5>
            }          
          </td>
          <td className="hidden-xs" style={{textAlign: 'center'}}>
            {this.state.status === 'Final' ? 
              <button className="btn btn-sm btn-info" onClick={this.resend}>{this.state.resending ? <Loader/> : 'RE-SEND'}</button>: this.state.test === 'pcr' ? "":<button className="btn btn-sm btn-primary" onClick={this.submit}>AG Final</button>
            }
          </td>
          <td className="hidden-xs" style={{textAlign: 'center'}}>
            {this.state.isPCR ? 
              <button className="btn btn-sm btn-success" onClick={this.reprint}>Reprint</button>:<button className="btn btn-sm btn-primary" onClick={this.submitToLab}>Send to Lab</button>
            }
          </td>
          <td className="hidden-xs" style={{textAlign: 'center'}}><button className="btn btn-sm btn-warning" onClick={this.edit}>Edit</button></td>
        </tr>
        {this.state.edit ? 
          <tr style={{backgroundColor: '#EAEDED'}}>
            <td colSpan={13}>
              <div className="row">
                <div className="col-xs-3">
                  <label>First Name</label>
                  <input className="form-control input-sm" name="firstName" value={this.state.firstName} onChange={this.handleChange}/>
                </div>
                <div className="col-xs-3">
                  <label>Last Name</label>
                  <input className="form-control input-sm" name="lastName" value={this.state.lastName} onChange={this.handleChange}/>
                </div>
                <div className="col-xs-3">
                  <label>DOB</label>
                  <input className="form-control input-sm" name="dob" value={this.state.dob} onChange={this.handleChange}/>
                </div>
                <div className="col-xs-3">
                  <label>Gender</label>
                  <select className="form-control input-sm" name="sex" value={this.state.sex} onChange={this.handleChange}>
                    <option value="">Select</option>
                    <option value="F">Female</option>
                    <option value="M">Male</option>
                    <option value="U">Prefer not to answer</option>
                  </select>
                </div>
              </div>
              <div className="row">
                <div className="col-xs-3">
                  <label>Address</label>
                  <input className="form-control input-sm" name="address" value={this.state.address} onChange={this.handleChange}/>
                </div>
                <div className="col-xs-3">
                  <label>City</label>
                  <input className="form-control input-sm" name="city" value={this.state.city} onChange={this.handleChange}/>
                </div>
                <div className="col-xs-3">
                  <label>State</label>
                  <select className="form-control input-sm" name="state" value={this.state.state} onChange={this.handleChange}>
                    {states.map(item => <option key={item.abbreviation} value={item.abbreviation}>{item.name}</option>)}
                  </select>                
                </div>
                <div className="col-xs-3">
                  <label>Zip</label>
                  <input className="form-control input-sm" name="zip" value={this.state.zip} onChange={this.handleChange}/>
                </div>
              </div>
              <div className="row">
                <div className="col-xs-3">
                  <label>Email</label>
                  <input className="form-control input-sm" name="email" value={this.state.email} onChange={this.handleChange}/>
                </div>
                <div className="col-xs-3">
                  <label>Phone</label>
                  <input className="form-control input-sm" name="phone" value={this.state.phone} onChange={this.handleChange}/>
                </div>
                <div className="col-xs-3">
                  <label>Test</label>
                  <select className="form-control input-sm" name="test" value={this.state.test} onChange={this.handleChange}>
                    <option value="">Select a test</option>
                    <option value="rapid">Covid-19 Antigen & PCR</option>
                    <option value="pcr">Covid-19 PCR Only</option>
                  </select>
                </div>
                <div className="col-xs-3"></div>
              </div>
              <div className="row">
                <div className="col-xs-3">
                  <br/>
                  <button className="btn btn-sm btn-primary btn-outline btn-block" onClick={this.update}>Update</button> 
                </div>
                <div className="col-xs-3"></div>
                <div className="col-xs-3"></div>
                <div className="col-xs-3"></div>
              </div>
              <br/>
            </td>
          </tr>: null
        }
        { this.state.showSubmitModal && <RequisitionSubmitModal patientID={this.state.id} labelCopies={this.state.labelCopies} onHide={this.print}/> }
        { this.state.openModal && this.renderModal()}
        { this.state.testModal && this.testModal()}
      </Fragment>
      
    )
  }
}

class List extends Component {
  constructor(props){
    console.log(props)
    super(props);
    this.state = {
      items: [],
      totalCount: '',
      hasMore: false,
      skip: 0,
      limit: 20,
      loading: true,

      searchByStatus: '',
      searchByLastName: '',
      searchByFirstName: '',
      searchByDate: '',
      searchByDOB: '',
      searchByAccession: '',

      dohModal: false,
      startDate: null,
      endDate: null,
      state: '',
      errors: [],

      printModal: false,
      startDate: moment().format('YYYY-MM-DD'),
      endDate: moment().format('YYYY-MM-DD')
    }
  }

  componentDidMount(){
    // this.loadData()
  }

  componentDidUpdate(prevState){
    if(this.state.loading && !prevState.loading){
      this.loadData()
    }
  }

  loadData = () => {
    let params = {
      skip: this.state.skip,
      limit: this.state.limit,
      searchByClientID: this.props.user.clientID
    }
    if (this.state.searchByStatus){
      params.searchByStatus = this.state.searchByStatus
    }
    if (this.state.searchByLastName){
      params.searchByLastName = this.state.searchByLastName
    }
    if (this.state.searchByFirstName){
      params.searchByFirstName = this.state.searchByFirstName
    }
    if (this.state.searchByDate){
      params.searchByDate = this.state.searchByDate
    }

    if (this.state.searchByDOB){
      params.searchByDOB = this.state.searchByDOB
    }
    if (this.state.searchByAccession){
      params.searchByAccession = this.state.searchByAccession
    }   

    axios({
      method: 'GET',
      url: `${process.env.REACT_APP_URL}/antigen`,
      params: params
    }).then(res => {
      console.log(res.data)
      this.setState({
        items: res.data.items,
        totalCount: res.data.totalCount,
        skip: res.data.skip,
        limit: res.data.limit,
        loading: false,
      })
    }).catch(err => {
      console.log(err)
      this.setState({
        items: [],
        loading: false,
      })
    });
  }

  handleChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    console.log(value)
    this.setState({
      [name]: value,
      // loading: true
    })
  }

  change = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    this.setState({
      [name]: value,
    })
  }

  onSkipChange = (skip) => {
    this.setState({
      skip: skip,
      loading: true
    })
  }

  clear = () => {
    this.setState({
      searchByStatus: '',
      searchByLastName: '',
      searchByFirstName: '',
      searchByDate: '',
      searchByDOB: '',
      searchByAccession: '',

      items: [],
      totalCount: '',
      hasMore: false,
      skip: 0,
      limit: 20,
    })
  }

  onClickDOH = () => {
    this.setState({
      dohModal: !this.state.dohModal,
      startDate: null,
      endDate: null,
      state: '',
      errors: [],
    })
  }

  onClickPrint = () => {
    this.setState({
      printModal: !this.state.printModal,
    })
  }

  generate = () => {
    let qs = [`clientID=${this.props.user.clientID}`];
    let errors = [];
    let isValid = true;
    if (this.state.startDate){
      qs.push(`startDate=${this.state.startDate}`)
    } else {
      isValid = false;
      errors.push('Start Date is required')
    }
    if (this.state.endDate){
      qs.push(`endDate=${this.state.endDate}`)
    } else {
      isValid = false;
      errors.push('End Date is required')
    }
    if (this.state.state){
      qs.push(`state=${this.state.state}`)
    } else {
      isValid = false;
      errors.push('State is required')
    }

    if (isValid){
      window.location.href = `${process.env.REACT_APP_URL_API || ""}/v0/doh/csv-range?${qs.map(item => item).join('&')}`;
    } else {
      this.setState({
        errors: errors
      })
    }    
  }

  print = () => {
    let qs = [`clientID=${this.props.user.clientID}`];
    qs.push(`startPrintDate=${this.state.startDate}`)
    qs.push(`endPrintDate=${this.state.endDate}`)
    window.open(`${process.env.REACT_APP_URL_API || ""}/v0/manifest?${qs.map(item => item).join('&')}`)
  }

  renderDOHmodal(){
    return(
      <div className="modal inmodal" style={{"display": this.state.dohModal ? 'block' : 'none' }} tabIndex="-1">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <button type="button" className="close" data-dismiss="modal" onClick={this.onClickDOH}>
                <span aria-hidden="true">x</span>
              </button>
              <h4 className="modal-title">Generate DOH File</h4>
            </div>
            <div className='modal-body'>
              <div className='row'>
                <div className='col-lg-4'>
                  <label>Start Date</label>
                  <input className='form-control' type='date' name="startDate" value={this.state.startDate} onChange={this.change}/>
                </div>
                <div className='col-lg-4'>
                  <label>End Date</label>
                  <input className='form-control' type='date' name="endDate" value={this.state.endDate} onChange={this.change}/>
                </div>
                <div className='col-lg-4'>
                  <label>State</label>
                  <select className='form-control' name="state" value={this.state.state} onChange={this.change}>
                    <option value=''>Select</option>
                    <option value='fl'>Florida</option>
                  </select>
                </div>
                {this.state.errors ?
                  <div className='col-lg-12'>
                    <ul style={{color: 'red', fontWeight: 'bold'}}>
                      {this.state.errors.map((item, index) => <li key={index}>{item}</li>)}
                    </ul>
                  </div> : null
                }
              </div>
            </div>
            <div className="modal-footer">
              <div className="button-group">
                <button className="btn btn-primary" onClick={this.generate}>Confirm</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderPrint(){
    return(
      <div className="modal inmodal" style={{"display": this.state.printModal ? 'block' : 'none' }} tabIndex="-1">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <button type="button" className="close" data-dismiss="modal" onClick={this.onClickPrint}>
                <span aria-hidden="true">x</span>
              </button>
              <h4 className="modal-title">Print Manifest</h4>
            </div>
            <div className='modal-body'>
              <div className='row'>
                <div className='col-lg-6'>
                  <label>Start Date</label>
                  <input className='form-control' type='date' name="startDate" value={this.state.startDate} onChange={this.change}/>
                </div>  
                <div className='col-lg-6'>
                  <label>End Date</label>
                  <input className='form-control' type='date' name="endDate" value={this.state.endDate} onChange={this.change}/>
                </div>               
              </div>
            </div>
            <div className="modal-footer">
              <div className="button-group">
                <button className="btn btn-primary" onClick={this.print}>Print</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  render(){
    return(
      <div className="row">
        <div className="col-xs-12">
          <div className="ibox req-ibox">
            <div className="ibox-title">
              <h5>Antigen List</h5>
              <button className='pull-right btn btn-xs btn-success' onClick={this.onClickDOH}>Export to DOH</button>
              <button className='pull-right btn btn-xs btn-warning' onClick={this.onClickPrint}>Print Manifest</button>
            </div>
            <div className="ibox-content">
            <strong className='text-danger'>NOTE: To avoid clerical errors and mislabel specimens, we removed the list of patients. You must physically search the patient to submit it to the Lab</strong>
              <div className='hidden-sm hidden-md hidden-lg'>
                <div className='row'>
                  <div className='col-xs-12'>
                    <input className="form-control input-sm" placeholder="Search By Last Name" name="searchByLastName" value={this.state.searchByLastName} onChange={this.handleChange}/>
                    <input className="form-control input-sm" placeholder="Search By First Name" name="searchByFirstName" value={this.state.searchByFirstName} onChange={this.handleChange}/>
                    <input className="form-control input-sm" 
                      placeholder="Search By DOB" 
                      name="searchByDOB" 
                      type='text'
                      value={this.state.searchByDOB} 
                      onChange={this.handleChange}
                      onFocus={(event) => event.target.type = 'date'}
                      onBlur={(event) => event.target.type = 'text'}
                      />
                  </div>
                </div>
                <div className='row'>
                  <div className='col-xs-6'>
                    <button className="btn btn-sm btn- btn-block" onClick={this.clear}>Clear</button>
                  </div>
                  <div className='col-xs-6'>
                    <button className="btn btn-sm btn-primary btn-block" onClick={this.loadData}><i className="fa fa-search"></i> Search</button>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-xs-12">
                  <table className="table table-condensed table-hover table-bordered">
                    <thead>
                      <tr>
                        <th className="hidden-xs"><button className="btn btn-sm btn-primary btn-block" onClick={this.loadData}><i className="fa fa-search"></i> Search</button></th>
                        <th className="hidden-xs"><input className="form-control input-sm" type='date' name="searchByDate" value={this.state.searchByDate} onChange={this.handleChange}/></th>
                        <th className="hidden-xs"><input className="form-control input-sm" placeholder="Search By Last Name" name="searchByLastName" value={this.state.searchByLastName} onChange={this.handleChange}/></th>
                        <th className="hidden-xs"><input className="form-control input-sm" placeholder="Search By First Name" name="searchByFirstName" value={this.state.searchByFirstName} onChange={this.handleChange}/></th>
                        <th className="hidden-xs"><input className="form-control input-sm" type='date' placeholder="Search By DOB" name="searchByDOB" value={this.state.searchByDOB} onChange={this.handleChange}/></th>
                        <th className="hidden-xs"></th>
                        <th className="hidden-xs"><input className="form-control input-sm" placeholder="Search By Accession" name="searchByAccession" value={this.state.searchByAccession} onChange={this.handleChange}/></th>
                        <th className="hidden-xs">
                          <select className="form-control input-sm" name="searchByStatus" value={this.state.searchByStatus} onChange={this.handleChange}>
                            <option value="">Search By Status</option>
                            <option value="pending">Pending</option>
                            <option value="accessioned">Accessioned</option>
                            <option value="final">Final</option>
                          </select>
                        </th>
                        <th className="hidden-xs"></th>
                        <th className="hidden-xs"></th>
                        <th className="hidden-xs"></th>
                        <th className="hidden-xs" style={{textAlign: 'center'}}><button className="btn btn-sm btn-default" onClick={this.clear}>Clear</button></th>
                      </tr>
                      <tr>
                        <th className="hidden-sm hidden-md hidden-lg">Patient Name</th>
                        <th className="hidden-sm hidden-md hidden-lg">Send to Lab</th>
                        <th className="hidden-xs">Order Number</th>
                        <th className="hidden-xs">Order Date</th>
                        <th className="hidden-xs">Last Name</th>
                        <th className="hidden-xs">First Name</th>
                        <th className="hidden-xs">DOB</th>
                        <th className="hidden-xs">Phone</th>
                        <th className="hidden-xs">AccessionID</th>
                        <th className="hidden-xs">Status</th>
                        <th className="hidden-xs">AG Result</th>
                        <th className="hidden-xs">Final AG</th>
                        <th className="hidden-xs">Send To Lab</th>
                        <th className="hidden-xs">Edit</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.items.map(item => <Item key={item.id} {...item}/>)}
                    </tbody>
                    <tfoot>
                      <tr>
                        <td colSpan={12} style={{textAlign: "center"}}>
                          <Pagination
                            pages={Math.ceil(this.state.totalCount/this.state.limit)}
                            activePage={this.state.skip/this.state.limit}
                            onPageChange={(page) => { this.onSkipChange(this.state.limit*page)}}
                          />
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>
          </div>
          {this.state.dohModal ? this.renderDOHmodal() : null}
          {this.state.printModal ? this.renderPrint() : null}
        </div>
      </div>
    )
  }
}
export default List